<template>
  <div class="wrapper">
    <FORM ref="childForm" @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable" :pageData="pageData"></table-page>
  </div>
</template>

<script>
import tablePage from '@/components/page/table.vue'
import FORM from '@/components/page/form.vue'
import DateUtil from '@/utils/IM/tradeDataUtil.js'
import Qs from 'qs'
import Url from '@/views/crs/util/url'
import download from '@/utils/download'

let statusArr = { 0: '未領取', 1: '已經領取', 2: '未完成' }
let quantityTypes = {
  1: '簽到',
  2: '推薦好友',
  3: '交易',
  4: '入金',
  5: '开通真实交易账号',
  6: '上传身份证',
  7: '绑定银行卡',
  8: '激活账号',
  9: '額外獎勵',
  10: '交易盈虧',
  1000: '兌換',
  1001: '兌換失敗回退',
  1002: '系統返利',
  2000: '抽獎消耗',
  2001: '抽獎獲取',
  2002: '大富翁活动',
  2003: '过山车活动'
}
let categoryTypes = {
  1: '每日任务',
  2: '成长任务',
  3: '限时任务',
  4: '特殊任务',
  5: '系統返利奖励',
  6: '活动',
  100: '其它方式',
  101: '兌換',
  102: '積分兌換提案',
  103: '日常任务额外奖励'
}

export default {
  name: 'list',
  components: {
    tablePage,
    FORM
  },
  methods: {

    /*查询表单按钮点击事件*/
    formclick(clickName, data) {
      if (window.$t('common.search') == clickName || '查询' == clickName) {
        this.queryData = data
        this.$refs.childTable.defaultGetData(data)
      } else if (window.$t('common.export') == clickName || '导出' == clickName) {
        this.queryData = data
        download.exportExcel(Url.quantityTask.quantityDetailExport, data, '積分詳情列表')
      }
    },

    dataChanage(url, option, suc, fail) {
      this.$axios.post(url, option || {}, { headers: { 'Content-Type': 'application/json' } }).then(res => {
        this.$refs.childTable.defaultGetData(this.queryData)
        if (suc && (typeof suc == 'function')) suc(res)
      }).catch(res => {
        if (fail && (typeof fail == 'function')) fail(res)
      })
    }

  },
  data() {
    return {
      queryData: {},
      /*from查询表单*/
      formData: {
        hasLable: true,
        cols: [
          {
            title: 'businessTypeAlias',
            field: 'businessTypeAlias',
            data: DateUtil.getParamKey(this.$route.params),
            hidden: true
          },
          { title: window.$t('crs.quantityTask.customerNumber'), field: 'customerNumber', isNumber: true },
          { title: window.$t('crs.quantityTask.phone'), field: 'phone' },
          {
            title: window.$t('crs.quantityTask.type'),
            field: 'typeId',
            type: 2,
            optionList: quantityTypes,
            multiple: false
          },
          {
            title: '活動類型',
            field: 'category',
            type: 2,
            optionList: categoryTypes,
            multiple: false
          },
          {
            title: window.$t('crs.quantityTask.status'),
            field: 'status',
            type: 2,
            optionList: statusArr,
            multiple: false
          },
          {
            title: window.$t('crs.quantityTask.startTime'),
            field: 'startTime',
            type: 5,
            format: 'yyyy-MM-dd HH:mm:ss'
          },
          {
            title: window.$t('crs.quantityTask.endTime'),
            field: 'endTime',
            type: 5,
            format: 'yyyy-MM-dd HH:mm:ss'
          },
          { click: window.$t('common.search') },
          { click: window.$t('common.export'), auth: 'crs:quantity:export' }
        ]
      },
      /*table生成*/
      pageData: {
        isShow: false,
        queryUrl: Url.quantityTask.detailQuery,
        selection: false,
        sequence: true,
        method: 'get',
        cols: [
          {
            title: window.$t('crs.quantityTask.ctime'), field: 'ctime', render: (data, full) => {
              return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
            }
          },
          { title: window.$t('crs.quantityTask.customerNumber'), field: 'customerNumber' },
          {
            title: window.$t('crs.quantityTask.activeTime'), field: 'activeTime', render: (data, full) => {
              if (data > 0) {
                return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
              }
              return null
            }
          },
          {
            title: window.$t('crs.quantityTask.acceptTime'), field: 'acceptTime', render: (data, full) => {
              if (data > 0) {
                return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
              }
              return null
            }
          },
          { title: window.$t('crs.quantityTask.userName'), field: 'userName' },
          { title: window.$t('crs.quantityTask.phone'), field: 'phone' },
          { title: '標題', field: 'name' },
          { title: window.$t('crs.quantityTask.taskName'), field: 'taskTitle' },
          {
            title: window.$t('crs.quantityTask.taskStep'), field: 'taskStep', render: (data, full) => {
              if (full.typeId === 1) {
                return '第<' + data + '>天打卡'
              } else {
                return data
              }
            }
          },
          {
            title: window.$t('crs.quantityTask.type'), field: 'typeId', render: (data, full) => {
              return quantityTypes[data]
            }
          },
          {
            title: window.$t('crs.quantityTask.quantity'), field: 'quantity', render: (data, full) => {
              if (data > 0) {
                return '+' + data
              } else {
                return data
              }
            }
          },
          { title: window.$t('crs.quantityTask.balance'), field: 'balance' },
          { title: window.$t('crs.quantityTask.proposalId'), field: 'proposalId' },
          {
            title: window.$t('crs.quantityTask.category'), field: 'category', render: (data, full) => {
              return categoryTypes[data]
            }
          },

          {
            title: window.$t('crs.quantityTask.status'), field: 'status', render: (data, full) => {
              return statusArr[data]
            }
          }
        ]
      }
    }
  }
}
</script>
